import { DimensionsInfo, RelativeVector2d } from '@/entities/collection';
import { Vector2d } from 'konva/lib/types';

export type CanvasState = {
  drawMode: DrawMode | null;
  dimensions: CanvasDimensions;
  mousePosition: Vector2d | null;
  bgRectangle: {
    topLeft: RelativeVector2d;
    bottomRight: RelativeVector2d | null;
  } | null;
};

export type CanvasDimensions = Pick<
  DimensionsInfo,
  'canvasWidth' | 'canvasHeight'
>;

export enum DrawMode {
  Background = 'BACKGROUND',
}
